type Logger = Pick<Console, "debug" | "error" | "info" | "warn">;

export const log: Logger = console;
